<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Azərbaycan vətəndaşları üçün viza tələbləri</h1>
        <input type="text" v-model="query" placeholder="Ölkənin adı">
        <table>
          <thead>
            <tr>
              <th>Ölkə</th>
              <th>Tələb</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredList">
              <td>{{ item.country }}</td>
              <td>{{ item.visa }}</td>
            </tr>
          </tbody>
        </table>
        <p class="note">Cədvəldə göstərilən məlumatlar "Timatic" bazasından götürülüb. Bəzi ölkələr əlavə sənədlər tələb edə bilər (gediş/qayıdış bileti, maddi vəziyyət və s.). Səyahətə çıxmazdan qabaq viza haqqında dəqiq məlumatları səfirliklərdən öyrənmək tövsiyə olunur.</p>
      </div>
    </div>
  </div>
</template>

<script> 
  export default {
    data(){
      return {
        query: '',
        list: [
          { 'country' : 'Əfqanıstan (Afghanistan)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Albaniya (Albania)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Cezayir (Algeria)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Argentina (Argentina)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Aruba (Aruba)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Avstraliya (Australia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Avstriya (Austria)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Bahamalar, The (Bahamas, The)', 'visa' : 'Viza tələb olunmur ( 3 ay )' },
          { 'country' : 'Bahreyn (Bahrain)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Bangladeş (Bangladesh)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Barbados (Barbados)', 'visa' : 'Viza tələb olunmur ( 28 gün )' },
          { 'country' : 'Belarus (Belarus)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Belçika (Belgium)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Beliz (Belize)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Boliviya (Bolivia)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Bosniya və Herseqovina (Bosnia and Herzegovina)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Braziliya (Brazil)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Brunei (Brunei)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Bolqarıstan (Bulgaria)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Burkina Faso (Burkina Faso)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Burundi (Burundi)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Kamerun (Cameroon)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Kanada (Canada)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Mərkəzi Afrika Respublikası (Central African Republic)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Çad (Chad)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Çili (Chile)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Çin (China)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Kolumbiya (Colombia)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Komorları (Comoros)', 'visa' : 'Viza tələb olunmur ( 45 gün )' },
          { 'country' : 'Konqo Demokratik Respublikası (Congo, Democratic Republic of the)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Konqo, Respublika (Congo, Republic of the)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Kosta Rika (Costa Rica)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Xorvatiya (Croatia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Kuba (Cuba)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Curacao (Curacao)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Kipr (Cyprus)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Çexiya Respublikası (Czech Republic )', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Danimarka (Denmark)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Cibuti (Djibouti)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Dominika (Dominica)', 'visa' : 'Viza tələb olunmur ( 21 gün )' },
          { 'country' : 'Dominik respublikası (Dominican Republic)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Ekvador (Ecuador)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Misir (Egypt)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'El Salvador (El Salvador)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Ekvatorial Qvineya (Equatorial Guinea)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Eritreya (Eritrea)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Estoniya (Estonia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Eswatini (Eswatini)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Fiji (Fiji)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Finlandiya (Finland)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Fransa (France)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Qabon (Gabon)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Gambiya (Gambia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Gürcüstan (Georgia)', 'visa' : 'Viza tələb olunmur ( 1 il )' },
          { 'country' : 'Almaniya (Germany)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Gana (Ghana)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Yunanıstan (Greece)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Qrenada (Grenada)', 'visa' : 'Viza tələb olunmur ( 3 ay )' },
          { 'country' : 'Qvatemala (Guatemala)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Qvineya (Guinea)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Qvineya-Bissau (Guinea-Bissau)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Guyana (Guyana)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Haiti (Haiti)', 'visa' : 'Viza tələb olunmur ( 3 ay )' },
          { 'country' : 'Honduras (Honduras)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Honq Konq (Hong Kong)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Macarıstan (Hungary)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'İslandiya (Iceland)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Hindistan (India)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'İran (Iran)', 'visa' : 'Viza tələb olunmur' },
          { 'country' : 'İraq (Iraq)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'İrlandiya (Ireland)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'İsrail (Israel)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'İtaliya (Italy)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Yamayka (Jamaica)', 'visa' : 'Viza tələb olunmur ( 6 ay )' },
          { 'country' : 'Yaponiya (Japan)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'İordaniya (Jordan)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Qazaxıstan (Kazakhstan)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Kenya (Kenya)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Kiribati (Kiribati)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Şimali Koreya (Korea, North)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Cənubi Koreya (Korea, South)', 'visa' : 'Viza tələb olunmur' },
          { 'country' : 'Kosovo (Kosovo)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Küveyt (Kuwait)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Qırğızıstan (Kyrgyzstan)', 'visa' : 'Viza tələb olunmur' },
          { 'country' : 'Latviya (Latvia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Livan (Lebanon)', 'visa' : 'Viza tələb olunmur ( 1 ay )' },
          { 'country' : 'Lesotho (Lesotho)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Liberya (Liberia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Libya (Libya)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Litva (Lithuania)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Lüksemburq (Luxembourg)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Makao (Macau)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Madaqaskar (Madagascar)', 'visa' : 'Viza tələb olunmur ( 3 ay )' },
          { 'country' : 'Malavi (Malawi)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Malayziya (Malaysia)', 'visa' : 'Viza tələb olunmur (1 ay )' },
          { 'country' : 'Maldivlər (Maldives)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Mali (Mali)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Malta (Malta)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Marşal adaları (Marshall Islands)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Mauritius (Mauritius)', 'visa' : 'Viza tələb olunmur ( 60 gün )' },
          { 'country' : 'Meksika (Mexico)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Mikroneziya (Micronesia)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Moldova (Moldova)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Monako (Monaco)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Monqolustan (Mongolia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Çernoqoriya (Montenegro)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Mərakeş (Morocco)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Mozambik (Mozambique)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Namibiya (Namibia)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Nauru (Nauru)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Nepal (Nepal)', 'visa' : 'Viza tələb olunmur ( 150 gün )' },
          { 'country' : 'Hollandiya (Netherlands)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Yeni Zelandiya (New Zealand)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Nikaraqua (Nicaragua)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Niger (Niger)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Nigeriya (Nigeria)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Şimali Makedoniya (North Macedonia)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Norveç (Norway)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Oman (Oman)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Pakistan (Pakistan)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Palau (Palau)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Fələstin əraziləri (Palestinian Territories)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Panama (Panama)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Papua Yeni Qvineya (Papua New Guinea)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Paraqvay (Paraguay)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Peru (Peru)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Filippin (Philippines)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Polşa (Poland)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Portuqaliya (Portugal)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Qatar (Qatar)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Rumıniya (Romania)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Rusiya (Russia)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Ruanda (Rwanda)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Sent-Kits və Nevis (Saint Kitts and Nevis)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Sent Lusiya (Saint Lucia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Sent Vinsent və Qrenadilər (Saint Vincent and the Grenadines)', 'visa' : 'Viza tələb olunmur ( 1 ay )' },
          { 'country' : 'Samoa (Samoa)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Səudiyyə Ərəbistanı (Saudi Arabia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Senegal (Senegal)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Serbiya (Serbia)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Seyşel adaları (Seychelles)', 'visa' : 'Viza tələb olunmur ( 1 ay )' },
          { 'country' : 'Sierra Leone (Sierra Leone)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Sinqapur (Singapore)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Sint Maarten (Sint Maarten)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Slovakiya (Slovakia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Sloveniya (Slovenia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Solomon adaları (Solomon Islands)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Cənubi Afrika (South Africa)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Cənubi Sudan (South Sudan)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'İspaniya (Spain)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Şri Lanka (Sri Lanka)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Sudan (Sudan)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Surinam (Suriname)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'İsveç (Sweden)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'İsveçrə (Switzerland)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Suriya (Syria)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Tayvan (Taiwan)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Tacikistan (Tajikistan)', 'visa' : 'Viza tələb olunmur ( 90 gün )' },
          { 'country' : 'Tanzaniya (Tanzania)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Tayland (Thailand)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Timor-Leste (Timor-Leste)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Getmək (Togo)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Tonqa (Tonga)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Trinidad və Tobaqo (Trinidad and Tobago)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Tunis (Tunisia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Türkiyə (Turkey)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Türkmənistan (Turkmenistan)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Tuvalu (Tuvalu)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Uqanda (Uganda)', 'visa' : 'Viza tələb olunmur ( 3 ay )' },
          { 'country' : 'Ukrayna (Ukraine)', 'visa' : 'Viza tələb olunmur' },
          { 'country' : 'Birləşmiş Ərəb Əmirlikləri (United Arab Emirates)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Birləşmiş Krallıq (United Kingdom)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Uruqvay (Uruguay)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Özbəkistan (Uzbekistan)', 'visa' : 'Viza tələb olunmur' },
          { 'country' : 'Vanuatu (Vanuatu)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Venesuela (Venezuela)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Vyetnam (Vietnam)', 'visa' : 'Viza tələb olunmur ( 30 gün )' },
          { 'country' : 'Yəmən (Yemen)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Zambiya (Zambia)', 'visa' : 'Viza tələb olunur' },
          { 'country' : 'Zimbabve (Zimbabwe)', 'visa' : 'Viza tələb olunmur ( 3 ay )' }
        ]
      }
    },    
    computed: {
      filteredList: function() {
        let query = this.query;
        return this.list.filter(function(dir) {
          return ( dir.country.toLowerCase().indexOf(query.toLowerCase()) !== -1 );
        });
      }
    }
  }
</script>

<style scoped>

table td,
table th {
  text-align: left;
}
table tr td:first-child {
  white-space: nowrap;
}

</style>


// WEBPACK FOOTER //
// src/components/calc/Visa.vue